import React, { useEffect, useState } from 'react';
import FormInputCEditor from '../../form-components/FormInputCEditor';
import { useForm } from 'react-hook-form';
import { Box, Button, Divider, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useToast } from 'use-toast-mui';
import { updateBranchPolicy } from '../../api/center-branch';
import { errorMessages } from '../../utils/methods';
import { useNavigate } from 'react-router-dom';

// 센터 이용약관 탭 정의
// - field: 백엔드 Branch 약관 필드명 (PATCH /branches/{id}/policies 요청 키)
// - label: 탭 라벨
const POLICY_TABS = [
  { field: 'termsOfUse', label: '센터 이용 약관' },
  { field: 'refundPolicy', label: '환불 약관' },
  { field: 'privacyPolicy', label: '개인정보 이용 동의' },
  { field: 'transferPolicy', label: '양도/양수 약관' },
  { field: 'advertisingPolicy', label: '광고성 정보 이용 동의' },
  { field: 'subscriptionTerms', label: '구독 결제 약관' },
];

const StoreTabBefore3 = ({ branchDetailInfo, branchId }) => {
  const { handleSubmit, control, setValue } = useForm();
  const toast = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = useSelector(state => state.user.user);
  // 현재 선택된 탭 인덱스 (0 ~ 4)
  const [selectedTab, setSelectedTab] = useState(0);
  // 각 탭 CKEditor 의 초기 내용 (지점 상세에서 채움)
  const [initialContents, setInitialContents] = useState({});

  useEffect(() => {
    if (!branchDetailInfo) return;
    const contents = {};
    POLICY_TABS.forEach(({ field }) => {
      contents[field] = branchDetailInfo[field] || '';
    });
    setInitialContents(contents);
  }, [branchDetailInfo]);

  // null 인 필드는 백엔드에서 변경하지 않으므로, 수정한 탭만 전송된다.
  const submit = async values => {
    if (!branchId) return;
    try {
      await updateBranchPolicy(values, branchId, user.token);
      toast.success(t('Successfully saved'));
      navigate('/store');
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  return (
    <div>
      <Box sx={{ mt: '12.5px', pb: '0px', height: '40px' }}>
        <Tabs
          sx={{
            '& .MuiTab-root.MuiTab-textColorSecondary': {
              borderRadius: '12px',
              border: '1px solid #0F7F85',
              mr: 1.25,
              minWidth: '100px',
              minHeight: '40px !important',
              padding: '12px 40px',
              fontWeight: 500,
              fontSize: '13px',
            },
            '& .MuiTab-root.MuiTab-textColorSecondary.Mui-selected': {
              background: '#0F7F85',
              borderRadius: '12px',
              border: 'none',
              color: '#fff',
            },
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
          value={selectedTab}
          onChange={(e, newValue) => setSelectedTab(newValue)}
          textColor="secondary"
          indicatorColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="center policy tabs">
          {POLICY_TABS.map((tab, index) => (
            <Tab key={tab.field} value={index} label={t(tab.label)} />
          ))}
        </Tabs>
      </Box>
      <Divider sx={{ mt: '0px', mb: '12.5px', p: '0px', color: '#e1e1e1' }} />

      {/* 모든 에디터를 마운트하고 선택된 탭만 노출 → 탭 전환 시 입력 내용 유지 */}
      {POLICY_TABS.map((tab, index) => (
        <Box
          key={tab.field}
          sx={{
            width: '1000px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            mt: 1,
            display: selectedTab === index ? 'flex' : 'none',
          }}>
          <FormInputCEditor
            sx={{ width: '100%' }}
            setValue={setValue}
            control={control}
            data={initialContents[tab.field]}
            name={tab.field}
            id={tab.field}
          />
        </Box>
      ))}

      <Divider sx={{ mt: '26px', mb: '26px', p: '0px', color: '#e1e1e1' }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          columnGap: '6px',
          pb: '60px',
        }}>
        <Button
          onClick={() => navigate(-1)}
          sx={{
            p: '12px 37px 11px 37px',
            borderRadius: '5px',
            height: '36px',
            width: '100px',
            background: '#98A6AD',
            color: '#fff',
            '&:hover': { background: '#ddd' },
          }}>
          {t('Cancel')}
        </Button>
        <Button
          onClick={handleSubmit(submit)}
          sx={{
            p: '12px 56px 11px 55px',
            borderRadius: '5px',
            height: '36px',
            width: '137px',
            background: '#0F7F85',
            color: '#fff',
            '&:hover': { background: '#0F7F85', color: '#fff' },
          }}>
          {t('Save')}
        </Button>
      </Box>
    </div>
  );
};

export default StoreTabBefore3;
